import React, { FunctionComponent } from 'react';

import LogoNormalSvg from '../images/logo-circle.svg';

const Logo: FunctionComponent = () => (
  <LogoNormalSvg className="header__logo" />
);
export default Logo;
